export default function AppEmpty() {
    return null;
}
